import { Component, computed, inject } from '@angular/core';
import { ActualizacionDeLaAppService } from './actualizacion-de-la-app.service';
import { OrderService } from '../../services/order.service';

/**
 * F2.7 — aviso discreto de versión nueva. Con el carrito vacío la app se
 * actualiza sola y este aviso casi no llega a verse; con una venta en curso dice
 * que se aplicará al terminarla.
 */
@Component({
  selector: 'app-aviso-de-actualizacion',
  standalone: true,
  template: `
    @if (app.avisoIrrecuperable()) {
      <div class="aviso-act" role="status" data-testid="aviso-actualizacion">
        Recargando el POS para corregir un problema de actualización…
      </div>
    } @else if (app.hayVersionNueva()) {
      <div class="aviso-act" role="status" data-testid="aviso-actualizacion">
        <span>Hay una versión nueva del POS.</span>
        @if (carritoVacio()) {
          <button type="button" class="aviso-act-btn" (click)="app.actualizarAhora()">Actualizar</button>
        } @else {
          <span class="aviso-act-sub">Se aplica al terminar esta venta.</span>
        }
      </div>
    }
  `,
  styles: [`
    .aviso-act { position: fixed; top: var(--esp-3); right: var(--esp-3); z-index: 1300; display: flex; align-items: center; gap: var(--esp-2);
      padding: var(--esp-2) var(--esp-3); border-radius: var(--radio-md); background: var(--color-slate-800); color: #fff;
      font-size: var(--texto-xs); box-shadow: 0 6px 18px rgb(0 0 0 / 20%); }
    .aviso-act-sub { opacity: .8; }
    .aviso-act-btn { border: 1px solid rgb(255 255 255 / 55%); background: transparent; color: inherit; font: inherit;
      padding: var(--esp-0) var(--esp-2); border-radius: var(--radio-pastilla); cursor: pointer; }
  `],
})
export class AvisoDeActualizacionComponent {
  readonly app = inject(ActualizacionDeLaAppService);
  private readonly orden = inject(OrderService);
  readonly carritoVacio = computed(() => this.orden.currentOrder().items.length === 0);
}
